import { AddressTypeEnum } from "./enums/AddressTypeEnum";

export class Address {
  id: string;
  street: string;
  number: number;
  suffix: string;
  postalCode: number;
  city: string;
  lamKey: string;
  addressType: AddressTypeEnum;
  studentHomeCount: number;
  isMainAddress: boolean;

  constructor(dto?: Partial<Address>) {
    Object.assign(this, dto);
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  getFullAddress() {
    return `${this.getShortAddress().trim()}, ${this.postalCode} ${this.city}`;
  }

  getShortAddress() {
    const items = [this.street, this.number, this.suffix];
    return items.filter((item) => item).join(" ");
  }
}
